var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F2F5FA"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B28D5B",
    d: "M16.11 14.302c0 .809-.656 1.465-1.465 1.465H1.465C.655 15.767 0 15.11 0 14.302V4.04h16.11v10.263z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99774F",
    d: "M0 4.039h2.563v11.728H1.465C.655 15.767 0 15.11 0 14.3V4.039zm16.11 5.13h-5.492c-.809 0-1.465.656-1.465 1.465v.003c0 .809.656 1.465 1.465 1.465h5.492c.404 0 .732-.328.732-.733V9.902c0-.404-.328-.732-.732-.732z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE77C",
    d: "M11.35 10.636c0 .303-.246.55-.55.55-.302 0-.548-.247-.548-.55 0-.304.246-.55.549-.55.303 0 .55.246.55.55z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CEA05D",
    d: "M15.011 5.871H1.831C.82 5.871 0 5.051 0 4.041v-.004c0-1.011.82-1.83 1.83-1.83h13.181c.607 0 1.099.491 1.099 1.098v1.468c0 .607-.492 1.098-1.099 1.098z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#84D88B",
    d: "M10.09.57l1.26 3.469H2.93L8.901.17c.432-.28 1.013-.085 1.19.4z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#91F18B",
    d: "M13.053.554L14.32 4.04H5.86l6-3.886c.434-.282 1.017-.086 1.194.401z",
    transform: "translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99774F",
    d: "M16.11 3.764v.55H2.197c-.152 0-.275-.123-.275-.275 0-.152.123-.275.275-.275H16.11z",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.3570b513.svg";
export { ForwardRef as ReactComponent };